export const BULK_COLUMNS = {
  ORDERS: [
    { key: "client_id", header: "Client ID" },
    { key: "reference_no", header: "Reference No" },
    { key: "receiver_name", header: "Receiver Name" },
    { key: "receiver_mobile", header: "Receiver Phone" },
    { key: "receiver_email", header: "Receiver Email" },
    { key: "receiver_country", header: "Receiver Country" },
    { key: "receiver_city", header: "Receiver City" },
    { key: "receiver_district", header: "Receiver District / Area" },
    { key: "receiver_address", header: "Receiver Address" },
    { key: "receiver_national_address", header: "Receiver National Address" },
    { key: "shipment_cost", header: "Shipment Cost" },
    { key: "payment_type", header: "Payment Type" },
    { key: "cod_amount", header: "COD Amount" },
    { key: "no_of_pieces", header: "No of Pieces" },
    { key: "weight", header: "Weight" },
    { key: "service", header: "Service" },
    { key: "shipment_type", header: "Shipment Type" },
    { key: "description", header: "Description" },
    { key: "latitude", header: "Latitute" },
    { key: "longitude", header: "Longitude" },
    { key: "reason", header: "Reason" },
  ],

  OUTSOURCE: [
    { key: "company_name", header: "Company Name" },
    { key: "full_name", header: "Full Name" },
    { key: "phone", header: "Phone" },
    { key: "email", header: "Email" },
    { key: "contact_person", header: "Contact Person" },
    { key: "contact_method", header: "Contact Method" },
    { key: "warehouse", header: "Warehouse" },
    { key: "payment_term", header: "Payment Term" },
    { key: "access_type", header: "Access Type" },
    { key: "client_type", header: "Client Type" },
    { key: "short_address", header: "Short Address" },
    { key: "location", header: "Full Address" },
    { key: "full_address", header: "Full Address" },
    { key: "vat_number", header: "VAT Number" },
    { key: "cr_number", header: "CR Number" },
    { key: "national_id", header: "National ID" },
    { key: "contract_date", header: "Contract Date" },
    { key: "address", header: "Address" },
    { key: "service_area", header: "Service Area" },
    { key: "billing_cycle", header: "Billing Cycle" },
    { key: "reason", header: "Reason" },
  ],

  CLIENT: [
    { key: "name", header: "Full Name" },
    { key: "mobile", header: "Phone" },
    { key: "email", header: "Email" },
    { key: "contact_person", header: "Contact Person" },
    { key: "contact_types", header: "Contact Method" },
    { key: "warehouse", header: "Warehouse" },
    { key: "payment_term", header: "Payment Term" },
    { key: "access", header: "Access Type" },
    { key: "client_type", header: "Client Type" },
    { key: "short_address", header: "Short Address" },
    { key: "location", header: "Full Address" },
    { key: "full_address", header: "Full Address" },
    { key: "vat_number", header: "VAT Number" },
    { key: "cr_number", header: "CR Number" },
    { key: "national_id", header: "National ID" },
    { key: "contract_date", header: "Contract Date" },
    { key: "reason", header: "Reason" },
  ],

  STAFF: [
    { key: "full_name", header: "Full Name" },
    { key: "email", header: "Email" },
    { key: "phone", header: "Phone" },
    { key: "warehouse", header: "Warehouse" },
    { key: "supervisor_name", header: "Supervisor Name" },
    { key: "roles", header: "Role" },
    { key: "start_date", header: "Start Date" },
    { key: "iqama_no", header: "Iqama Number" },
    { key: "reason", header: "Reason" },
  ],

  DRIVERS: [
    { key: "name", header: "Full Name" },
    { key: "mobile_no", header: "Phone" },
    { key: "email", header: "Email" },
    { key: "warehouse", header: "Warehouse" },
    { key: "supervisor_name", header: "Supervisor Name" },
    { key: "start_date", header: "Start Date" },
    { key: "iqama_number", header: "Iqama Number" },
    { key: "vehicle_type", header: "Vehicle Type" },
    { key: "vehicle_name", header: "Vehicle Name" },
    { key: "license_number", header: "License Number" },
    { key: "reason", header: "Reason" },
  ],

  FM_ORDERS: [
    { key: "client_id",                header: "Client ID" },
    { key: "reference_no",             header: "Reference No" },
    { key: "receiver_name",            header: "Receiver Name" },
    { key: "receiver_mobile",          header: "Receiver Phone" },
    { key: "receiver_email",           header: "Receiver Email" },
    { key: "receiver_country",         header: "Receiver Country" },
    { key: "receiver_city",            header: "Receiver City" },
    { key: "receiver_district",        header: "Receiver District / Area" },
    { key: "receiver_address",         header: "Receiver Address" },
    { key: "receiver_national_address",header: "Receiver National Address" },
    { key: "shipment_cost",            header: "Shipment Cost" },
    { key: "payment_type",             header: "Payment Type (CC, COD)" },
    { key: "cod_amount",               header: "COD Amount" },
    { key: "no_of_pieces",             header: "No of Pieces" },
    { key: "service",                  header: "Service" },
    { key: "description",              header: "Description" },
    { key: "latitude",                 header: "Latitude" },
    { key: "longitude",                header: "Longitude" },
    { key: "product_id_1",             header: "Product ID 1" },
    { key: "quantity_1",               header: "Quantity 1" },
    { key: "product_id_2",             header: "Product ID 2" },
    { key: "quantity_2",               header: "Quantity 2" },
    { key: "product_id_3",             header: "Product ID 3" },
    { key: "quantity_3",               header: "Quantity 3" },
    { key: "product_id_4",             header: "Product ID 4" },
    { key: "quantity_4",               header: "Quantity 4" },
    { key: "product_id_5",             header: "Product ID 5" },
    { key: "quantity_5",               header: "Quantity 5" },
  ],

  ITEMS: [
    { key: "itemName", header: "Item Name" },
    { key: "sku", header: "SKU" },
    { key: "category", header: "Category" },
    { key: "subCategory", header: "Sub Category" },
    { key: "storage_type", header: "Storage Type" },
    { key: "capacity", header: "Capacity" },
    { key: "minimum_quantity", header: "Minimum Quantity" },
    { key: "length", header: "Length" },
    { key: "width", header: "Width" },
    { key: "height", header: "Height" },
    { key: "weight", header: "Weight" },
    { key: "expiry", header: "Expiry" },
    { key: "commodity", header: "Commodity" },
    { key: "import_commodity", header: "Import Commodity" },
    { key: "dangerous_goods", header: "Dangerous Goods" },
    { key: "hs_code", header: "HS Code" },
    { key: "price1", header: "Price 1" },
    { key: "price2", header: "Price 2" },
    { key: "discount", header: "Discount" },
    { key: "minimum_order", header: "Minimum Order" },
    { key: "short_description", header: "Short Description" },
    { key: "long_description", header: "Long Description" },
    { key: "tags", header: "Tags" },
    { key: "reason", header: "Reason" },
  ],

  VEHICLES: [
    { key: "company", header: "Company" },
    { key: "vehicle_type", header: "Vehicle Type" },
    { key: "model", header: "Model" },
    { key: "year", header: "Year" },
    { key: "fuel_type", header: "Fuel Type" },
    { key: "vehicle_number", header: "Vehicle Number" },
    { key: "registration_type", header: "Registration Type" },
    { key: "color", header: "Color" },
    { key: "sequence_number", header: "Sequence Number" },
    { key: "odometer", header: "Odometer" },
    { key: "rc_number", header: "Rc Number" },
    { key: "inspection_expiry_date", header: "Inspection Expiry Date" },
    { key: "registration_expiry_date", header: "Registration Expiry Date" },
    { key: "insurance_company", header: "Insurance Company" },
    { key: "insurance_start_date", header: "Insurance Start Date" },
    { key: "insurance_end_date", header: "Insurance End Date" },
    { key: "reason", header: "Reason" },
  ],
};

// ─────────────────────────────────────────────────────────────────────────────
// FAILED ROWS COLUMNS (Only key identifiers + reason)
// ─────────────────────────────────────────────────────────────────────────────
export const FAIL_COLUMNS = {
  ORDERS: [
    { key: "reference_no", header: "Reference No" },
    { key: "client_id", header: "Client ID" },
    { key: "reason", header: "Reason" },
  ],

  CLIENT: [
    { key: "name", header: "Full Name" },
    { key: "mobile", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],

  OUTSOURCE: [
    { key: "company_name", header: "Company Name" },
    { key: "mobile", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],

  STAFF: [
    { key: "full_name", header: "Full Name" },
    { key: "phone", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],

  DRIVERS: [
    { key: "name", header: "Full Name" },
    { key: "mobile_no", header: "Phone" },
    { key: "reason", header: "Reason" },
  ],

  ITEMS: [
    { key: "itemName", header: "Item Name" },
    { key: "sku", header: "SKU" },
    { key: "category", header: "Category" },
    { key: "subCategory", header: "Sub Category" },
    { key: "reason", header: "Reason" },
  ],

  VEHICLES: [
    { key: "vehicle_number", header: "Vehicle Number" },
    { key: "sequence_number", header: "Sequence Number" },
    { key: "reason", header: "Reason" },
  ],
};


